import {
  UseWriteContractAndConfirmReturnType,
  useWriteContractAndConfirm,
} from 'hooks/contracts/useWriteContractAndConfirm';
import { TransactionAction } from 'hooks/notifications/useWalletNotifications';
import {
  CROWDLOAN_REWARDS_CONTRACT_ADDRESS,
  CrowdloanRewardsContractABI,
} from 'services/contracts/CrowdloanRewards/constants';
import { CrowdloanRewardsFunctions } from 'types/contracts/functions';

const action = TransactionAction.CLAIM;

export function useClaimCrowdloanRewards(): UseWriteContractAndConfirmReturnType {
  return useWriteContractAndConfirm({
    action,
    contractAddress: CROWDLOAN_REWARDS_CONTRACT_ADDRESS,
    contractAbi: CrowdloanRewardsContractABI,
    functionName: CrowdloanRewardsFunctions.CLAIM,
  });
}
